import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import pageNotFound from '../../assets/pageNotFound.jpg';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        pageNotFoundContainer: {
            background: `linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%), url(${pageNotFound})`,
            backgroundSize: 'cover',
            color: 'white',
            textAlign: 'center',
            padding: '50px 0px 50px 0px',
            backgroundPosition: 'center',
            [theme.breakpoints.only('sm')]: {
                padding: '50px 0px 0px 0px'
            },
            [theme.breakpoints.down('xs')]: {
                padding: '20px 5px 20px 5px'
            }
        },
        informationContainer: {
            fontSize: '50px',
            marginLeft: '30px',
            [theme.breakpoints.only('md')]: {
                fontSize: '30px'
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '25px',
                margin: '0px 5px 0px 5px'
            }
        },
        homeContainer: {
            margin: '20px 0 30px 0'
        },
        homeButton: {
            backgroundColor: '#D32F2F',
            color: '#fff',
            width: '250px',
            '&:hover': {
                backgroundColor: '#212121'
            }
        },
        errorCode: {
            fontSize: '160px',
            [theme.breakpoints.only('md')]: {
                fontSize: '140px'
            },
            [theme.breakpoints.down('sm')]:{
                fontSize:'100px'
            }
        },
        verticalDivider: {
            borderLeft: '2px solid #fff',
            height: '400px',
            [theme.breakpoints.down('sm')]:{
                display:'none'
            }
        }
    })
);